import { partnerApplicationMachine } from '~domains/partner-application/entities/application';

import { StateValueFrom } from 'xstate';

type PartnerStateValue = StateValueFrom<typeof partnerApplicationMachine>;

type PartnerSectionState = Extract<PartnerStateValue, string>;

type PickByKey<TUnion, TKey extends string> = TUnion extends unknown
  ? [keyof TUnion] extends [TKey]
    ? TUnion
    : never
  : never;

type BusinessBlockMember = PickByKey<PartnerStateValue, 'businessBlock'>;

type PartnerBusinessState = Extract<
  NonNullable<BusinessBlockMember[keyof BusinessBlockMember]>,
  string
>;

export const PARTNER_APPLICATION_NAV_SECTIONS = {
  businessInfo: 'businessBlock',
  stores: 'storesBlock',
  agents: 'agentsBlock',
  finish: 'review',
} as const satisfies Record<string, PartnerSectionState>;

export type PartnerApplicationNavSectionId =
  (typeof PARTNER_APPLICATION_NAV_SECTIONS)[keyof typeof PARTNER_APPLICATION_NAV_SECTIONS];

export const PARTNER_APPLICATION_NAV_STEPS = {
  businessType: 'ownership',
  businessDetails: 'businessDetails',
  registeredAddress: 'businessAddress',
  mainOfficeAddress: 'officeAddress',
  businessDocuments: 'businessDocuments',
  bankAccount: 'bankDetails',
} as const satisfies Record<string, PartnerBusinessState>;

export type PartnerApplicationNavStepId =
  (typeof PARTNER_APPLICATION_NAV_STEPS)[keyof typeof PARTNER_APPLICATION_NAV_STEPS];
